import { NgModule } from '@angular/core';
import { GetAddressPipe } from './get-address.pipe';

@NgModule({
    declarations: [GetAddressPipe],
    exports: [GetAddressPipe],
})
export class GetAddressPipeModule {}